import Queries from '@containers/PerformanceManagement/Queries';
import nmos_new from '@containers/PerformanceManagement/Queries_Irancell2';
import nmos from '@containers/PerformanceManagement/Queries2';
import rightel from '@containers/PerformanceManagement/Queries_Rightel';
import PSshare from '@containers/PerformanceManagement/Rightel_PSshare';
import Rightel_ps_cs_daily from '@containers/PerformanceManagement/Rightel_ps_cs_daily';
import CarrierShare from '@containers/PerformanceManagement/Rightel_CarrierShare';
import ReportRepo from '@containers/PerformanceManagement/ReportRepo';
import DashboardUMTS from '@containers/PerformanceManagement/Rightel/DashboardUMTS';
import Dashboard from '@containers/PerformanceManagement/Rightel/Dashboard';
import FrameLoss from '@containers/PerformanceManagement/Rightel_frame_loss';
import RTWP from '@containers/PerformanceManagement/Rightel_rtwp';
import SleepingCellLTE from '@containers/PerformanceManagement/Rightel_sleeping_cell_LTE';
import SleepingCellUMTS from '@containers/PerformanceManagement/Rightel_sleeping_cell_UMTS';
import PUCCH from '@containers/PerformanceManagement/Rightel_pucch';
import irancell from '@containers/PerformanceManagement/Queries_Irancell';
import compare from '@containers/ConfigurationManagement/Ret/compare';
import Generator from '@containers/PerformanceManagement/Generator';
import Download from '@containers/ConfigurationManagement/Download';
import Compare from '@containers/ConfigurationManagement/Compare';
import View from '@containers/ConfigurationManagement/View';
import Alerts from '@containers/ConfigurationManagement/Alerts';
import Overview from '@containers/Overview';
import mainChart from '@containers/Rightel/Dashboard';
import PPC from '@containers/PerformanceManagement/Rightel_PPC';
import WDC from '@containers/PerformanceManagement/Rightel_WDC';
// import UserManagement from "@containers/UserManagement";
import TiltInAtolandConfig from '@containers/ConfigurationManagement/TiltInAtolandConfig';
import Workspace from '@containers/PerformanceManagement/Workspace';
import P1P2 from '@containers/PerformanceManagement/P1P2';
import Import from '@containers/PerformanceManagement/Import';
import KML from '@containers/PerformanceManagement/KML';
import Logs from '@containers/Atoll/Logs';
import Roles from '@containers/Atoll/Roles';
import Errors from '@containers/Atoll/Errors';
import Access from '@containers/Atoll/Access';
import Transmission from '@containers/Transmission';
import Planning from '@containers/Planning';
import Legends from '@containers/WebGIS/Legends';
import Propagation from '@containers/WebGIS/Propagation';
import PPS from '@containers/PerformanceManagement/PPS';
import Discrepancy from '@containers/Transmission/discrepancy';
import BrTelMCI_Import from '@containers/BrTelMCI/CM/Import';
import BrTelMCI_CM_Download from '@containers/BrTelMCI/CM/Download';
import BrTelMCI_CmNotInPM from '@containers/BrTelMCI/CM/cmNotInPM';
import BrTelMCI_CM_Compare from '@containers/BrTelMCI/CM/Compare';
import BrTelMCI_PM_Browser from '@containers/BrTelMCI/PM/Browser';
import CellFile_Brtel from '@containers/BrTelMCI/Planning/CellFile';
import CellRef_Brtel from '@containers/BrTelMCI/Planning/CellRef';
import KML_Brtel from '@containers/BrTelMCI/Planning/KML';
import Nemo_Brtel from '@containers/BrTelMCI/Planning/Nemo/index';
import CompareIP from '@containers/Transmission/CompareIp';
import Borders_Brtel from '@containers/BrTelMCI/Planning/Borders';
import Active_Parameter_Aras from '@containers/BrTelMCI/CM/Active_Parameter_Aras';
import CellRef_Rightel from '@containers/Rightel/planning/CellRef';
import CellFile_Rightel from '@containers/Rightel/planning/CellFile';
import KML_Rightel from '@containers/Rightel/planning/KML';
import Borders_Rightel from '@containers/Rightel/planning/Borders';
import Nemo_Rightel from '@containers/Rightel/planning/Nemo';
import Rightel_CM_Compare from '@containers/Rightel/CM/Compare';
import Download_Rightel from '@containers/Rightel/CM/Download';
import Import_Rightel from '@containers/Rightel/CM/Import';
import WPC from '@containers/Rightel/pm/wpc';
import Percent_change from '@containers/Rightel/pm/percent_change';
import Map from '@containers/Map';
import Tracker from '@containers/Irancell/cm/tracker';
import Tracker2 from '@containers/Irancell/cm/tracker2';
import Utilization from '@containers/Rightel/pm/utilization_report';
import KML_utilization from '@containers/PerformanceManagement/KML_utilization';
import KPIeditor from '@containers/PerformanceManagement/KPIeditor';
import Queries2 from '@containers/PerformanceManagement/Queries_Rightel2';
import Clusters from '@containers/PerformanceManagement/Cluster';
import { queries } from '@testing-library/react';
import CM_Dashboard from '@containers/ConfigurationManagement/CM_Dashboard';
import jwt_decode from 'jwt-decode';
import Queries_HFN from '@containers/PerformanceManagement/Queries_HFN';
import KPIeditor_hfn from '@containers/PerformanceManagement/KPIeditor_hfn';
import KPIeditor_rightel_frameless from '@containers/PerformanceManagement/KPIeditor_rightel_frameless';
// import Profile from "@containers/Common/Profile";
// import Setting from "@containers/Common/Setting";
// import VideoArchive from "@containers/VideoArchive/VideoArchive";
export default function getRoutes(companyName) {
  const token = jwt_decode(localStorage.getItem('plano-jwt'));
  const user =
    token['http://schemas.xmlsoap.org/ws/2005/05/identity/claims/name'];
  const managementUsers = [
    'iman.f@mtnirancell.ir',
    'sirous.re@mtnirancell.ir',
    'farhad.gha@mtnirancell.ir',
    'farzam.e@mtnirancell.ir',
    'safiyeh.s@mtnirancell.ir',
  ];
  if (['test subcon'].includes(companyName.toLowerCase())) {
    return [
      {
        url: '/dashboard/overview',
        exact: true,
        roles: ['SUPERADMIN', 'ADMIN', 'OPERATOR', 'VIEW'],
        icon: 'pi pi-microsoft',
        label: 'Dasboard',
        isMenuItem: true,
        main: Overview,
      },
      {
        url: '/dashboard/map',
        exact: true,
        roles: ['SUPERADMIN', 'ADMIN', 'OPERATOR', 'VIEW'],
        icon: 'pi pi-wifi',
        label: 'Map',
        isMenuItem: true,
        main: Map,
      },
      {
        name: '/dashboard/pm',
        exact: false,
        roles: ['SUPERADMIN', 'ADMIN', 'OPERATOR', 'VIEW'],
        icon: 'pi pi-chart-bar',
        label: 'PM and Reporting',
        isMenuItem: true,
        items: [
          {
            url: '/dashboard/pm/dashboard',
            exact: true,
            roles: ['SUPERADMIN', 'ADMIN', 'OPERATOR', 'VIEW'],
            label: 'PM Dashboard',
            isMenuItem: true,
            main: Workspace,
            org: [],
          },
          // {
          //   url: "/kpi-browser",
          //   exact: true,
          //   roles: ["SUPERADMIN", "ADMIN", "OPERATOR", "VIEW"],
          //   label: "KPi Browser",
          //   isMenuItem: true,
          //   main: Queries,
          // },
          {
            url: '/dashboard/pm/hfn/browser',
            exact: true,
            roles: ['SUPERADMIN', 'ADMIN', 'OPERATOR', 'VIEW'],
            label: 'HFN Browser',
            isMenuItem: true,
            main: Queries_HFN,
            org: [],
          },
          {
            url: '/dashboard/pm/hfn/kpieditor_frameless',
            exact: true,
            roles: ['SUPERADMIN', 'ADMIN', 'OPERATOR', 'VIEW'],
            label: 'HFN KPI Editor',
            isMenuItem: true,
            main: KPIeditor_rightel_frameless,
            org: [],
          },
          {
            url: '/dashboard/pm/hfn/kpieditor',
            exact: true,
            roles: ['SUPERADMIN', 'ADMIN', 'OPERATOR', 'VIEW'],
            label: 'HFN KPI Editor',
            isMenuItem: true,
            main: KPIeditor_hfn,
            org: [],
          },
          {
            url: '/dashboard/pm/nmos',
            exact: true,
            roles: ['SUPERADMIN', 'ADMIN', 'OPERATOR', 'VIEW'],
            label: 'KPi Browser',
            isMenuItem: true,
            main: nmos,
            org: [],
          },
          {
            url: '/dashboard/pm/nmos2',
            exact: true,
            roles: ['SUPERADMIN', 'ADMIN', 'OPERATOR', 'VIEW'],
            label: 'KPi Browser New',
            isMenuItem: true,
            main: nmos_new,
            org: [],
          },
          {
            url: '/dashboard/pm/legends',
            exact: true,
            roles: ['SUPERADMIN', 'ADMIN', 'OPERATOR', 'VIEW'],
            label: 'Legends',
            isMenuItem: true,
            main: Legends,
          },

          {
            url: '/dashboard/pm/irancell',
            exact: true,
            roles: ['SUPERADMIN', 'ADMIN', 'OPERATOR', 'VIEW'],
            label: 'IOS KPi Browser',
            isMenuItem: true,
            main: irancell,
            org: [],
          },
          {
            url: '/dashboard/pm/kpi-generator',
            exact: true,
            roles: ['SUPERADMIN', 'ADMIN', 'OPERATOR', 'VIEW'],
            label: 'KPi Generator',
            isMenuItem: true,
            main: Generator,
            org: [],
          },
          {
            url: '/dashboard/pm/import',
            exact: true,
            roles: ['SUPERADMIN', 'ADMIN', 'OPERATOR', 'VIEW'],
            label: 'Import',
            isMenuItem: true,
            main: Planning.Import,
            org: [],
          },
          {
            url: '/dashboard/pm/kml',
            exact: true,
            roles: ['SUPERADMIN', 'ADMIN', 'OPERATOR', 'VIEW'],
            label: 'KML',
            isMenuItem: true,
            main: KML,
            org: [],
          },
          {
            url: '/dashboard/pm/kml_utilization',
            exact: true,
            roles: ['SUPERADMIN', 'ADMIN', 'OPERATOR', 'VIEW'],
            label: 'KML utilization',
            isMenuItem: true,
            main: KML_utilization,
            org: [],
          },
          {
            url: '/dashboard/pm/p1-p2',
            exact: true,
            roles: ['SUPERADMIN', 'ADMIN', 'OPERATOR', 'VIEW'],
            label: 'P1 P2',
            isMenuItem: true,
            main: P1P2,
            org: [],
          },
          {
            url: '/dashboard/pm/pps',
            exact: true,
            roles: ['SUPERADMIN', 'ADMIN', 'OPERATOR', 'VIEW'],
            label: 'PPS',
            isMenuItem: true,
            main: PPS,
            org: [],
          },
        ],
      },

      {
        name: '/dashboard/cm',
        exact: false,
        roles: ['SUPERADMIN', 'ADMIN', 'OPERATOR', 'VIEW'],
        icon: 'pi pi-slack',
        label: 'CM',
        isMenuItem: true,
        items: [
          {
            url: '/dashboard/cm/dashboard',
            exact: true,
            roles: ['SUPERADMIN', 'ADMIN', 'OPERATOR', 'VIEW'],
            label: 'Dashboard',
            isMenuItem: true,
            main: CM_Dashboard,
            org: [],
          },
          {
            url: '/dashboard/cm/view',
            exact: true,
            roles: ['SUPERADMIN', 'ADMIN', 'OPERATOR', 'VIEW'],
            label: 'View',
            isMenuItem: true,
            main: View,
            org: [],
          },
          {
            url: '/dashboard/cm/tracker',
            exact: true,
            roles: ['SUPERADMIN', 'ADMIN', 'OPERATOR', 'VIEW'],
            label: 'Tracker',
            isMenuItem: true,
            main: Tracker2,
            org: [],
          },
          {
            url: '/dashboard/cm/ret/compare',
            exact: true,
            roles: ['SUPERADMIN', 'ADMIN', 'OPERATOR', 'VIEW'],
            label: 'RET Compare',
            isMenuItem: true,
            main: compare,
            org: [],
          },
          {
            url: '/dashboard/cm/ret/toCell',
            exact: true,
            roles: ['SUPERADMIN', 'ADMIN', 'OPERATOR', 'VIEW'],
            label: 'RET Compare Atoll',
            isMenuItem: true,
            main: TiltInAtolandConfig,
            org: [],
          },
          {
            url: '/dashboard/cm/compare',
            exact: true,
            roles: ['SUPERADMIN', 'ADMIN', 'OPERATOR', 'VIEW'],
            label: 'Compare',
            isMenuItem: true,
            main: Compare,
            org: [],
          },
          {
            url: '/dashboard/cm/download',
            exact: true,
            roles: ['SUPERADMIN', 'ADMIN', 'OPERATOR', 'VIEW'],
            label: 'Download',
            isMenuItem: true,
            main: Download,
            org: [],
          },
          {
            url: '/dashboard/cm/alert',
            exact: true,
            roles: ['SUPERADMIN', 'ADMIN', 'OPERATOR', 'VIEW'],
            label: 'Alerts',
            isMenuItem: true,
            main: Alerts,
            org: [],
          },
        ],
      },

      {
        name: '/dashboard/brtel',
        exact: false,
        roles: ['SUPERADMIN', 'ADMIN', 'OPERATOR', 'VIEW'],
        icon: (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="h-6 w-6"
            viewBox="0 0 20 20"
            fill="currentColor"
          >
            <path
              fillRule="evenodd"
              d="M5 3a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2V5a2 2 0 00-2-2H5zm9 4a1 1 0 10-2 0v6a1 1 0 102 0V7zm-3 2a1 1 0 10-2 0v4a1 1 0 102 0V9zm-3 3a1 1 0 10-2 0v1a1 1 0 102 0v-1z"
              clipRule="evenodd"
            />
          </svg>
        ),
        label: 'Brtel Mci',
        isMenuItem: true,
        items: [
          {
            url: '/view',
            exact: true,
            roles: ['SUPERADMIN', 'ADMIN', 'OPERATOR', 'VIEW'],
            label: 'Parameter Aras',
            isMenuItem: true,
            main: Active_Parameter_Aras,
            org: [],
          },
          {
            url: '/import',
            exact: true,
            roles: ['SUPERADMIN', 'ADMIN', 'OPERATOR', 'VIEW'],
            label: 'Add Link',
            isMenuItem: true,
            main: BrTelMCI_Import,
            org: [],
          },
          {
            url: '/cellRef',
            exact: true,
            roles: ['SUPERADMIN', 'ADMIN', 'OPERATOR', 'VIEW'],
            label: 'Cell Ref',
            isMenuItem: true,
            main: CellRef_Brtel,
            org: [],
          },
          {
            url: '/cellFile',
            exact: true,
            roles: ['SUPERADMIN', 'ADMIN', 'OPERATOR', 'VIEW'],
            label: 'Cell File',
            isMenuItem: true,
            main: CellFile_Brtel,
            org: [],
          },
          {
            url: '/KML',
            exact: true,
            roles: ['SUPERADMIN', 'ADMIN', 'OPERATOR', 'VIEW'],
            label: 'KML',
            isMenuItem: true,
            main: KML_Brtel,
            org: [],
          },
          {
            url: '/borders',
            exact: true,
            roles: ['SUPERADMIN', 'ADMIN', 'OPERATOR', 'VIEW'],
            label: 'Borders',
            isMenuItem: true,
            main: Borders_Brtel,
          },
          {
            url: '/nemo',
            exact: true,
            roles: ['SUPERADMIN', 'ADMIN', 'OPERATOR', 'VIEW'],
            label: 'Nemo',
            isMenuItem: true,
            main: Nemo_Brtel,
          },
          {
            url: '/compare',
            exact: true,
            roles: ['SUPERADMIN', 'ADMIN', 'OPERATOR', 'VIEW'],
            label: 'CM Compare',
            isMenuItem: true,
            main: BrTelMCI_CM_Compare,
            org: [],
          },
          {
            url: '/cm/download',
            exact: true,
            roles: ['SUPERADMIN', 'ADMIN', 'OPERATOR', 'VIEW'],
            label: 'CM Download',
            isMenuItem: true,
            main: BrTelMCI_CM_Download,
            org: [],
          },
          {
            url: '/pm/browser',
            exact: true,
            roles: ['SUPERADMIN', 'ADMIN', 'OPERATOR', 'VIEW'],
            label: 'PM Browser',
            isMenuItem: true,
            main: BrTelMCI_PM_Browser,
            org: [],
          },
        ],
      },
      {
        name: '/dashboard/rightel',
        exact: false,
        roles: ['SUPERADMIN', 'ADMIN', 'OPERATOR', 'VIEW'],
        icon: (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="h-6 w-6"
            viewBox="0 0 20 20"
            fill="currentColor"
          >
            <path
              fillRule="evenodd"
              d="M5 3a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2V5a2 2 0 00-2-2H5zm9 4a1 1 0 10-2 0v6a1 1 0 102 0V7zm-3 2a1 1 0 10-2 0v4a1 1 0 102 0V9zm-3 3a1 1 0 10-2 0v1a1 1 0 102 0v-1z"
              clipRule="evenodd"
            />
          </svg>
        ),
        label: 'Rightel',
        isMenuItem: true,
        items: [
          {
            url: '/dashboard/rightel/mainChart',
            exact: true,
            roles: ['SUPERADMIN', 'ADMIN', 'OPERATOR', 'VIEW'],
            // icon: (
            //   <svg
            //     xmlns="http://www.w3.org/2000/svg"
            //     className="h-6 w-6"
            //     viewBox="0 0 20 20"
            //     fill="currentColor"
            //   >
            //     <path
            //       fillRule="evenodd"
            //       d="M3 3a1 1 0 000 2v8a2 2 0 002 2h2.586l-1.293 1.293a1 1 0 101.414 1.414L10 15.414l2.293 2.293a1 1 0 001.414-1.414L12.414 15H15a2 2 0 002-2V5a1 1 0 100-2H3zm11 4a1 1 0 10-2 0v4a1 1 0 102 0V7zm-3 1a1 1 0 10-2 0v3a1 1 0 102 0V8zM8 9a1 1 0 00-2 0v2a1 1 0 102 0V9z"
            //       clipRule="evenodd"
            //     />
            //   </svg>
            // ),
            label: 'Dashboard',
            isMenuItem: true,
            main: mainChart,
          },
          {
            url: '/dashboard/rightel/q2',
            exact: true,
            roles: ['SUPERADMIN', 'ADMIN', 'OPERATOR', 'VIEW'],
            label: 'Query2',
            isMenuItem: true,
            main: Queries2,
            org: [],
          },
          {
            url: '/dashboard/rightel/cluster',
            exact: true,
            roles: ['SUPERADMIN', 'ADMIN', 'OPERATOR', 'VIEW'],
            label: 'Cluster',
            isMenuItem: true,
            main: Clusters,
            org: [],
          },
          {
            url: '/dashboard/rightel/import',
            exact: true,
            roles: ['SUPERADMIN', 'ADMIN', 'OPERATOR', 'VIEW'],
            label: 'Import',
            isMenuItem: true,
            main: Import_Rightel,
            org: [],
          },
          {
            url: '/dashboard/rightel/kpiEditor',
            exact: true,
            roles: ['SUPERADMIN', 'ADMIN', 'OPERATOR', 'VIEW'],
            label: 'KPI Editor',
            isMenuItem: true,
            main: KPIeditor,
            org: [],
          },
          {
            url: '/dashboard/rightel/cellRef',
            exact: true,
            roles: ['SUPERADMIN', 'ADMIN', 'OPERATOR', 'VIEW'],
            label: 'Planing Cell Ref',
            isMenuItem: true,
            main: CellRef_Rightel,
            org: [],
          },
          {
            url: '/dashboard/rightel/cellFile',
            exact: true,
            roles: ['SUPERADMIN', 'ADMIN', 'OPERATOR', 'VIEW'],
            label: 'Planing Cell File',
            isMenuItem: true,
            main: CellFile_Rightel,
            org: [],
          },
          {
            url: '/dashboard/rightel/KML',
            exact: true,
            roles: ['SUPERADMIN', 'ADMIN', 'OPERATOR', 'VIEW'],
            label: 'Planing KML',
            isMenuItem: true,
            main: KML_Rightel,
            org: [],
          },
          {
            url: '/dashboard/rightel/borders',
            exact: true,
            roles: ['SUPERADMIN', 'ADMIN', 'OPERATOR', 'VIEW'],
            label: 'Planing Borders',
            isMenuItem: true,
            main: Borders_Rightel,
          },
          {
            url: '/dashboard/rightel/nemo',
            exact: true,
            roles: ['SUPERADMIN', 'ADMIN', 'OPERATOR', 'VIEW'],
            label: 'Planing Nemo',
            isMenuItem: true,
            main: Nemo_Rightel,
          },
          {
            url: '/dashboard/rightel/compare',
            exact: true,
            roles: ['SUPERADMIN', 'ADMIN', 'OPERATOR', 'VIEW'],
            label: 'CM Compare',
            isMenuItem: true,
            main: Rightel_CM_Compare,
            org: [],
          },
          {
            url: '/dashboard/rightel/cm/download',
            exact: true,
            roles: ['SUPERADMIN', 'ADMIN', 'OPERATOR', 'VIEW'],
            label: 'CM Download',
            isMenuItem: true,
            main: Download_Rightel,
            org: [],
          },
          {
            url: '/dashboard/rightel/wpc',
            exact: true,
            roles: ['SUPERADMIN', 'ADMIN', 'OPERATOR', 'VIEW'],
            label: 'PM WPC',
            isMenuItem: true,
            main: WPC,
            org: [],
          },

          {
            url: '/dashboard/rightel/percent_change',
            exact: true,
            roles: ['SUPERADMIN', 'ADMIN', 'OPERATOR', 'VIEW'],
            label: ' PM Percent Change',
            isMenuItem: true,
            main: Percent_change,
            org: [],
          },
          {
            url: '/dashboard/rightel/PPC',
            exact: true,
            roles: ['SUPERADMIN', 'ADMIN', 'OPERATOR', 'VIEW'],
            label: 'PM PPC',
            isMenuItem: true,
            main: PPC,
            org: [],
          },
          {
            url: '/dashboard/rightel/wdc',
            exact: true,
            roles: ['SUPERADMIN', 'ADMIN', 'OPERATOR', 'VIEW'],
            label: 'PM WDC',
            isMenuItem: true,
            main: WDC,
            org: [],
          },
          {
            url: '/dashboard/rightel/FrameLoss',
            exact: true,
            roles: ['SUPERADMIN', 'ADMIN', 'OPERATOR', 'VIEW'],
            label: 'PM Frame Loss',
            isMenuItem: true,
            main: FrameLoss,
            org: [],
          },
          {
            url: '/dashboard/rightel/ReportRepo',
            exact: true,
            roles: ['SUPERADMIN', 'ADMIN', 'OPERATOR', 'VIEW'],
            label: 'Report Repository',
            isMenuItem: true,
            main: ReportRepo,
            org: [],
          },
          {
            url: '/dashboard/rightel/dashboardUMTS',
            exact: true,
            roles: ['SUPERADMIN', 'ADMIN', 'OPERATOR', 'VIEW'],
            label: ' PM dashboardUMTS',
            isMenuItem: true,
            main: DashboardUMTS,
            org: [],
          },
          {
            url: '/dashboard/rightel/dashboard',
            exact: true,
            roles: ['SUPERADMIN', 'ADMIN', 'OPERATOR', 'VIEW'],
            label: ' PM Dashboards',
            isMenuItem: true,
            main: Dashboard,
            org: [],
          },
          {
            url: '/dashboard/rightel/psshare',
            exact: true,
            roles: ['SUPERADMIN', 'ADMIN', 'OPERATOR', 'VIEW'],
            label: 'PM PS share',
            isMenuItem: true,
            main: PSshare,
            org: [],
          },
          {
            url: '/dashboard/rightel/rightel_ps_cs_daily',
            exact: true,
            roles: ['SUPERADMIN', 'ADMIN', 'OPERATOR', 'VIEW'],
            label: 'PM rightel_ps_cs_daily',
            isMenuItem: true,
            main: Rightel_ps_cs_daily,
            org: [],
          },
          {
            url: '/dashboard/rightel/carriershare',
            exact: true,
            roles: ['SUPERADMIN', 'ADMIN', 'OPERATOR', 'VIEW'],
            label: 'PM Carier share',
            isMenuItem: true,
            main: CarrierShare,
            org: [],
          },

          {
            url: '/dashboard/rightel/wpc_4g',
            exact: true,
            roles: ['SUPERADMIN', 'ADMIN', 'OPERATOR', 'VIEW'],
            label: 'PM WPC 4G rightel',
            isMenuItem: true,
            main: WPC,
            org: [],
          },
          {
            url: '/dashboard/rightel/rightel',
            exact: true,
            roles: ['SUPERADMIN', 'ADMIN', 'OPERATOR', 'VIEW'],
            label: 'PM KPi Browser',
            isMenuItem: true,
            main: rightel,
            org: [],
          },
          {
            url: '/dashboard/rightel/utilization',
            exact: true,
            roles: ['SUPERADMIN', 'ADMIN', 'OPERATOR', 'VIEW'],
            label: 'Utilization',
            isMenuItem: true,
            main: Utilization,
            org: [],
          },
          {
            url: '/dashboard/pm/pucch',
            exact: true,
            roles: ['SUPERADMIN', 'ADMIN', 'OPERATOR', 'VIEW'],
            label: 'PUCCH > -107',
            isMenuItem: true,
            main: PUCCH,
            org: [],
          },
          {
            url: '/dashboard/pm/rtwp',
            exact: true,
            roles: ['SUPERADMIN', 'ADMIN', 'OPERATOR', 'VIEW'],
            label: 'RTWP > -95',
            isMenuItem: true,
            main: RTWP,
            org: [],
          },
          {
            url: '/dashboard/pm/carriershare',
            exact: true,
            roles: ['SUPERADMIN', 'ADMIN', 'OPERATOR', 'VIEW'],
            label: 'Sector Balance',
            isMenuItem: true,
            main: CarrierShare,
            org: [],
          },
          {
            url: '/dashboard/pm/SleepingCellLTE',
            exact: true,
            roles: ['SUPERADMIN', 'ADMIN', 'OPERATOR', 'VIEW'],
            label: 'Sleeping Cell LTE',
            isMenuItem: true,
            main: SleepingCellLTE,
            org: [],
          },
          {
            url: '/dashboard/pm/SleepingCellUMTS',
            exact: true,
            roles: ['SUPERADMIN', 'ADMIN', 'OPERATOR', 'VIEW'],
            label: 'Sleeping Cell UMTS',
            isMenuItem: true,
            main: SleepingCellUMTS,
            org: [],
          },
        ],
      },

      {
        name: '/dashboard/gis',
        exact: false,
        roles: ['SUPERADMIN', 'ADMIN', 'OPERATOR', 'VIEW'],
        icon: (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="h-5 w-5"
            viewBox="0 0 20 20"
            fill="currentColor"
          >
            <path
              fillRule="evenodd"
              d="M12 1.586l-4 4v12.828l4-4V1.586zM3.707 3.293A1 1 0 002 4v10a1 1 0 00.293.707L6 18.414V5.586L3.707 3.293zM17.707 5.293L14 1.586v12.828l2.293 2.293A1 1 0 0018 16V6a1 1 0 00-.293-.707z"
              clipRule="evenodd"
            />
          </svg>
        ),
        label: 'GIS',
        isMenuItem: true,
        items: [
          {
            url: '/dashboard/gis/legends',
            exact: true,
            roles: ['SUPERADMIN', 'ADMIN', 'OPERATOR', 'VIEW'],
            label: 'Legends',
            isMenuItem: true,
            main: Legends,
          },
          {
            url: '/dashboard/gis/propagation',
            exact: true,
            roles: ['SUPERADMIN', 'ADMIN', 'OPERATOR', 'VIEW'],
            label: 'Propagation',
            isMenuItem: true,
            main: Propagation,
          },
        ],
      },

      {
        name: '/dashboard/atoll',
        exact: true,
        roles: ['SUPERADMIN', 'ADMIN', 'OPERATOR', 'VIEW'],
        label: 'Atoll',
        isMenuItem: true,
        icon: (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="h-5 w-5"
            viewBox="0 0 20 20"
            fill="currentColor"
          >
            <path d="M4 4a2 2 0 012-2h4.586A2 2 0 0112 2.586L15.414 6A2 2 0 0116 7.414V16a2 2 0 01-2 2h-1.528A6 6 0 004 9.528V4z" />
            <path
              fillRule="evenodd"
              d="M8 10a4 4 0 00-3.446 6.032l-1.261 1.26a1 1 0 101.414 1.415l1.261-1.261A4 4 0 108 10zm-2 4a2 2 0 114 0 2 2 0 01-4 0z"
              clipRule="evenodd"
            />
          </svg>
        ),
        items: [
          {
            url: '/dashboard/atoll/logs',
            exact: true,
            roles: ['SUPERADMIN', 'ADMIN', 'OPERATOR', 'VIEW'],
            label: 'Logs',
            isMenuItem: true,
            main: Logs,
          },
          {
            url: '/dashboard/atoll/roles',
            exact: true,
            roles: ['SUPERADMIN', 'ADMIN', 'OPERATOR', 'VIEW'],
            label: 'Roles',
            isMenuItem: true,
            main: Roles,
          },
          {
            url: '/dashboard/atoll/errors',
            exact: true,
            roles: ['SUPERADMIN', 'ADMIN', 'OPERATOR', 'VIEW'],
            label: 'Errors',
            isMenuItem: true,
            main: Errors,
          },
          {
            url: '/dashboard/atoll/access',
            exact: true,
            roles: ['SUPERADMIN', 'ADMIN', 'OPERATOR', 'VIEW'],
            label: 'Access',
            isMenuItem: true,
            main: Access,
          },
        ],
      },
      {
        name: '/dashboard/transmission',
        exact: true,
        roles: ['SUPERADMIN', 'ADMIN', 'OPERATOR', 'VIEW'],
        label: 'Transmission',
        isMenuItem: true,
        icon: (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="h-5 w-5"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M8 7h12m0 0l-4-4m4 4l-4 4m0 6H4m0 0l4 4m-4-4l4-4"
            />
          </svg>
        ),
        items: [
          {
            url: '/dashboard/transmission/dashboard',
            exact: true,
            roles: ['SUPERADMIN', 'ADMIN', 'OPERATOR', 'VIEW'],
            label: 'Dashboard',
            isMenuItem: true,
            main: Transmission.Dashboard,
          },
          {
            url: '/dashboard/transmission/compareIP',
            exact: true,
            roles: ['SUPERADMIN', 'ADMIN', 'OPERATOR', 'VIEW'],
            label: 'Compare IP',
            isMenuItem: true,
            main: CompareIP,
          },
          {
            url: '/dashboard/transmission/import',
            exact: true,
            roles: ['SUPERADMIN', 'ADMIN', 'OPERATOR', 'VIEW'],
            label: 'Import Data',
            isMenuItem: true,
            main: Planning.Import,
          },
          {
            url: '/dashboard/transmission/microwave',
            exact: true,
            roles: ['SUPERADMIN', 'ADMIN', 'OPERATOR', 'VIEW'],
            label: 'Microwave List',
            isMenuItem: true,
            main: Transmission.MicrowaveList,
          },
          {
            url: '/dashboard/transmission/nes',
            exact: true,
            roles: ['SUPERADMIN', 'ADMIN', 'OPERATOR', 'VIEW'],
            label: 'NE List2',
            isMenuItem: true,
            main: Transmission.NEList,
          },
          {
            url: '/dashboard/transmission/reports',
            exact: true,
            roles: ['SUPERADMIN', 'ADMIN', 'OPERATOR', 'VIEW'],
            label: 'Reports',
            isMenuItem: true,
            main: Transmission.Reports,
          },
          // {
          //   url: '/dashboard/transmission/hub_report',
          //   exact: true,
          //   roles: ['SUPERADMIN', 'ADMIN', 'OPERATOR', 'VIEW'],
          //   label: 'HUB Report',
          //   isMenuItem: true,
          //   main: Transmission.HubReport,
          // },
          // {
          //   url: '/dashboard/transmission/hld_report',
          //   exact: true,
          //   roles: ['SUPERADMIN', 'ADMIN', 'OPERATOR', 'VIEW'],
          //   label: 'HLD Report',
          //   isMenuItem: true,
          //   main: Transmission.HLD,
          // },
        ],
      },
      {
        name: '/dashboard/planning',
        exact: true,
        roles: ['SUPERADMIN', 'ADMIN', 'OPERATOR', 'VIEW'],
        label: 'Planning',
        isMenuItem: true,
        icon: 'pi pi-book',
        items: [
          {
            url: '/dashboard/planning/dashbord',
            exact: true,
            roles: ['SUPERADMIN', 'ADMIN', 'OPERATOR', 'VIEW'],
            label: 'Dashbord',
            isMenuItem: true,
            main: Planning.Dashboard,
          },
          {
            url: '/dashboard/planning/import',
            exact: true,
            roles: ['SUPERADMIN', 'ADMIN', 'OPERATOR', 'VIEW'],
            label: 'Import',
            isMenuItem: true,
            main: Planning.Import,
          },
          // {
          //   url: "/AtollUpdate",
          //   exact: true,
          //   roles: ["SUPERADMIN", "ADMIN", "OPERATOR", "VIEW"],
          //   label: "Atoll Update",
          //   isMenuItem: true,
          //   main: Planning.AtollUpdate,
          // },
          {
            url: '/dashboard/planning/file-analyze',
            exact: true,
            roles: ['SUPERADMIN', 'ADMIN', 'OPERATOR', 'VIEW'],
            label: 'FileAnalyze',
            isMenuItem: true,
            main: Planning.FileAnalyze,
          },
          {
            url: '/dashboard/planning/view',
            exact: true,
            roles: ['SUPERADMIN', 'ADMIN', 'OPERATOR', 'VIEW'],
            label: 'View',
            isMenuItem: true,
            main: Planning.View,
          },
          {
            url: '/dashboard/planning/kml',
            exact: true,
            roles: ['SUPERADMIN', 'ADMIN', 'OPERATOR', 'VIEW'],
            label: 'KML',
            isMenuItem: true,
            main: Planning.KML,
          },
          {
            url: '/dashboard/planning/cell-file',
            exact: true,
            roles: ['SUPERADMIN', 'ADMIN', 'OPERATOR', 'VIEW'],
            label: 'Cell File',
            isMenuItem: true,
            main: Planning.CellFile,
          },
          {
            url: '/dashboard/planning/cell-ref',
            exact: true,
            roles: ['SUPERADMIN', 'ADMIN', 'OPERATOR', 'VIEW'],
            label: 'Cell Ref',
            isMenuItem: true,
            main: Planning.CellRef,
          },
          {
            url: '/dashboard/planning/borders',
            exact: true,
            roles: ['SUPERADMIN', 'ADMIN', 'OPERATOR', 'VIEW'],
            label: 'Borders',
            isMenuItem: true,
            main: Planning.Borders,
          },
          {
            url: '/dashboard/planning/atoll-check',
            exact: true,
            roles: ['SUPERADMIN', 'ADMIN', 'OPERATOR', 'VIEW'],
            label: 'Atoll Check',
            isMenuItem: true,
            main: Planning.AtollCheck,
          },
          {
            url: '/dashboard/planning/export-atoll',
            exact: true,
            roles: ['SUPERADMIN', 'ADMIN', 'OPERATOR', 'VIEW'],
            label: 'Atoll Download',
            isMenuItem: true,
            main: Planning.AtollDownload,
          },
          {
            url: '/dashboard/planning/violation',
            exact: true,
            roles: ['SUPERADMIN', 'ADMIN', 'OPERATOR', 'VIEW'],
            label: 'Violation',
            isMenuItem: true,
            main: Planning.Violation,
          },
          {
            url: '/dashboard/planning/nemo',
            exact: true,
            roles: ['SUPERADMIN', 'ADMIN', 'OPERATOR', 'VIEW'],
            label: 'Nemo',
            isMenuItem: true,
            main: Planning.Nemo,
          },
          {
            url: '/dashboard/planning/ep',
            exact: true,
            roles: ['SUPERADMIN', 'ADMIN', 'OPERATOR', 'VIEW'],
            label: 'EP Report',
            isMenuItem: true,
            main: Planning.EP_Report,
          },
        ],
      },
      // {
      //   url: "/dashboard/users",
      //   exact: true,
      //   roles: ["SUPERADMIN", "ADMIN"],
      //   label: "User Management",
      //   isMenuItem: true,
      //   icon: (
      //     <svg
      //       xmlns="http://www.w3.org/2000/svg"
      //       className="h-5 w-5"
      //       viewBox="0 0 20 20"
      //       fill="currentColor"
      //     >
      //       <path d="M9 6a3 3 0 11-6 0 3 3 0 016 0zM17 6a3 3 0 11-6 0 3 3 0 016 0zM12.93 17c.046-.327.07-.66.07-1a6.97 6.97 0 00-1.5-4.33A5 5 0 0119 16v1h-6.07zM6 11a5 5 0 015 5v1H1v-1a5 5 0 015-5z" />
      //     </svg>
      //   ),
      //   main: UserManagement,
      // },
      {
        url: '/dashboard/setting',
        exact: true,
        main: () => <div className="p-5">Setting</div>,
      },
      {
        url: '/dashboard/profile',
        exact: true,
        main: () => <div className="p-5">Profile</div>,
      },
    ];
  } else if (['hfn', 'test subucon'].includes(companyName.toLowerCase())) {
    const defaultAccess = [
      {
        url: '/dashboard/overview',
        exact: true,
        roles: ['SUPERADMIN', 'ADMIN', 'OPERATOR', 'VIEW'],
        icon: 'pi pi-microsoft',
        label: 'Dasboard',
        isMenuItem: true,
        main: Overview,
      },
      {
        name: '/dashboard/pm',
        exact: false,
        roles: ['SUPERADMIN', 'ADMIN', 'OPERATOR', 'VIEW'],
        icon: 'pi pi-chart-bar',
        label: 'PM and Reporting',
        isMenuItem: true,
        items: [
          // {
          //   url: "/performance-query-dashboard",
          //   exact: true,
          //   roles: ["SUPERADMIN", "ADMIN", "OPERATOR", "VIEW"],
          //   label: "PM Dashboard",
          //   isMenuItem: true,
          //   main: Workspace,
          //   org: []
          // },
          // {
          //   url: "/kpi-browser",
          //   exact: true,
          //   roles: ["SUPERADMIN", "ADMIN", "OPERATOR", "VIEW"],
          //   label: "KPi Browser",
          //   isMenuItem: true,
          //   main: Queries,
          // },
          {
            url: '/dashboard/pm/nmos2',
            exact: true,
            roles: ['SUPERADMIN', 'ADMIN', 'OPERATOR', 'VIEW'],
            label: 'Trans KPi Browser',
            isMenuItem: true,
            main: nmos_new,
            org: [],
          },
          {
            url: '/dashboard/pm/hfn/browser',
            exact: true,
            roles: ['SUPERADMIN', 'ADMIN', 'OPERATOR', 'VIEW'],
            label: 'Radio KPI Browser',
            isMenuItem: true,
            main: Queries_HFN,
            org: [],
          },
          {
            url: '/dashboard/pm/hfn/kpieditor',
            exact: true,
            roles: ['SUPERADMIN', 'ADMIN', 'OPERATOR', 'VIEW'],
            label: 'KPI Editor',
            isMenuItem: true,
            main: KPIeditor_hfn,
            org: [],
          },
          // {
          //   url: "/nmos",
          //   exact: true,
          //   roles: ["SUPERADMIN", "ADMIN", "OPERATOR", "VIEW"],
          //   label: "KPi Browser",
          //   isMenuItem: true,
          //   main: nmos,
          //   org: [],
          // },
          // {
          //   url: "/dashboard/irancell",
          //   exact: true,
          //   roles: ["SUPERADMIN", "ADMIN", "OPERATOR", "VIEW"],
          //   label: "IOS KPi Browser",
          //   isMenuItem: true,
          //   main: irancell,
          //   org: [],
          // },
          {
            url: '/dashboard/pm/legends',
            exact: true,
            roles: ['SUPERADMIN', 'ADMIN', 'OPERATOR', 'VIEW'],
            label: 'Legends',
            isMenuItem: true,
            main: Legends,
          },
          {
            url: '/dashboard/pm/kml_utilization',
            exact: true,
            roles: ['SUPERADMIN', 'ADMIN', 'OPERATOR', 'VIEW'],
            label: 'KML utilization',
            isMenuItem: true,
            main: KML_utilization,
            org: [],
          },

          {
            url: '/dashboard/pm/kpi-generator',
            exact: true,
            roles: ['SUPERADMIN', 'ADMIN', 'OPERATOR', 'VIEW'],
            label: 'KPi Generator',
            isMenuItem: true,
            main: Generator,
            org: [],
          },
          {
            url: '/dashboard/pm/import',
            exact: true,
            roles: ['SUPERADMIN', 'ADMIN', 'OPERATOR', 'VIEW'],
            label: 'Import',
            isMenuItem: true,
            main: Planning.Import,
            org: [],
          },
          {
            url: '/dashboard/pm/kml',
            exact: true,
            roles: ['SUPERADMIN', 'ADMIN', 'OPERATOR', 'VIEW'],
            label: 'KML',
            isMenuItem: true,
            main: KML,
            org: [],
          },
          // {
          //   url: "/p1-p2",
          //   exact: true,
          //   roles: ["SUPERADMIN", "ADMIN", "OPERATOR", "VIEW"],
          //   label: "P1 P2",
          //   isMenuItem: true,
          //   main: P1P2,
          //   org: []
          // },
          // {
          //   url: "/pps",
          //   exact: true,
          //   roles: ["SUPERADMIN", "ADMIN", "OPERATOR", "VIEW"],
          //   label: "PPS",
          //   isMenuItem: true,
          //   main: PPS,
          //   org: []
          // },
        ],
      },
      {
        name: '/dashboard/cm',
        exact: false,
        roles: ['SUPERADMIN', 'ADMIN', 'OPERATOR', 'VIEW'],
        icon: 'pi pi-slack',
        label: 'CM',
        isMenuItem: true,
        items: [
          // {
          //   url: "/view",
          //   exact: true,
          //   roles: ["SUPERADMIN", "ADMIN", "OPERATOR", "VIEW"],
          //   label: "View",
          //   isMenuItem: true,
          //   main: View,
          //   org: []
          // },
          {
            url: '/dashboard/cm/import',
            exact: true,
            roles: ['SUPERADMIN', 'ADMIN', 'OPERATOR', 'VIEW'],
            label: 'Import',
            isMenuItem: true,
            main: Planning.Import,
          },
          {
            url: '/dashboard/cm/tracker',
            exact: true,
            roles: ['SUPERADMIN', 'ADMIN', 'OPERATOR', 'VIEW'],
            label: 'Tracker',
            isMenuItem: true,
            main: Tracker2,
            org: [],
          },
          {
            url: '/dashboard/cm/ret/compare',
            exact: true,
            roles: ['SUPERADMIN', 'ADMIN', 'OPERATOR', 'VIEW'],
            label: 'RET Compare',
            isMenuItem: true,
            main: compare,
            org: [],
          },
          {
            url: '/dashboard/cm/ret/toCell',
            exact: true,
            roles: ['SUPERADMIN', 'ADMIN', 'OPERATOR', 'VIEW'],
            label: 'RET Compare Atoll',
            isMenuItem: true,
            main: TiltInAtolandConfig,
            org: [],
          },
          // {
          //   url: "/compare",
          //   exact: true,
          //   roles: ["SUPERADMIN", "ADMIN", "OPERATOR", "VIEW"],
          //   label: "Compare",
          //   isMenuItem: true,
          //   main: Compare,
          //   org: []
          // },
          // {
          //   url: "/download",
          //   exact: true,
          //   roles: ["SUPERADMIN", "ADMIN", "OPERATOR", "VIEW"],
          //   label: "Download",
          //   isMenuItem: true,
          //   main: Download,
          //   org: []
          // },
          // {
          //   url: "/alert",
          //   exact: true,
          //   roles: ["SUPERADMIN", "ADMIN", "OPERATOR", "VIEW"],
          //   label: "Alerts",
          //   isMenuItem: true,
          //   main: Alerts,
          //   org: []
          // },
        ],
      },
      {
        name: '/dashboard/transmission',
        exact: true,
        roles: ['SUPERADMIN', 'ADMIN', 'OPERATOR', 'VIEW'],
        label: 'Transmission',
        isMenuItem: true,
        icon: 'pi pi-globe',
        items: [
          // {
          //   url: "/dashboard",
          //   exact: true,
          //   roles: ["SUPERADMIN", "ADMIN", "OPERATOR", "VIEW"],
          //   label: "Dashboard",
          //   isMenuItem: true,
          //   main: Transmission.Dashboard,
          // },
          {
            url: '/dashboard/transmission/compareIP',
            exact: true,
            roles: ['SUPERADMIN', 'ADMIN', 'OPERATOR', 'VIEW'],
            label: 'Compare IP',
            isMenuItem: true,
            main: CompareIP,
          },
          {
            url: '/dashboard/transmission/import',
            exact: true,
            roles: ['SUPERADMIN', 'ADMIN', 'OPERATOR', 'VIEW'],
            label: 'Import Data',
            isMenuItem: true,
            main: Planning.Import,
          },
          {
            url: '/dashboard/transmission/microwave',
            exact: true,
            roles: ['SUPERADMIN', 'ADMIN', 'OPERATOR', 'VIEW'],
            label: 'Microwave List',
            isMenuItem: true,
            main: Transmission.MicrowaveList,
          },
          {
            url: '/dashboard/transmission/nes',
            exact: true,
            roles: ['SUPERADMIN', 'ADMIN', 'OPERATOR', 'VIEW'],
            label: 'NE List2',
            isMenuItem: true,
            main: Transmission.NEList,
          },
          {
            url: '/dashboard/transmission/reports',
            exact: true,
            roles: ['SUPERADMIN', 'ADMIN', 'OPERATOR', 'VIEW'],
            label: 'Reports',
            isMenuItem: true,
            main: Transmission.Reports,
          },
          // {
          //   url: '/dashboard/transmission/hub_report',
          //   exact: true,
          //   roles: ['SUPERADMIN', 'ADMIN', 'OPERATOR', 'VIEW'],
          //   label: 'HUB Report',
          //   isMenuItem: true,
          //   main: Transmission.HubReport,
          // },
          // {
          //   url: '/dashboard/transmission/hld_report',
          //   exact: true,
          //   roles: ['SUPERADMIN', 'ADMIN', 'OPERATOR', 'VIEW'],
          //   label: 'HLD Report',
          //   isMenuItem: true,
          //   main: Transmission.HLD,
          // },
        ],
      },
      {
        name: '/dashboard/planning',
        exact: true,
        roles: ['SUPERADMIN', 'ADMIN', 'OPERATOR', 'VIEW'],
        label: 'Planning',
        isMenuItem: true,
        icon: 'pi pi-book',
        items: [
          {
            url: '/dashboard/planning/dashbord',
            exact: true,
            roles: ['SUPERADMIN', 'ADMIN', 'OPERATOR', 'VIEW'],
            label: 'Dashbord',
            isMenuItem: true,
            main: Planning.Dashboard,
          },
          {
            url: '/dashboard/planning/import',
            exact: true,
            roles: ['SUPERADMIN', 'ADMIN', 'OPERATOR', 'VIEW'],
            label: 'Import',
            isMenuItem: true,
            main: Planning.Import,
          },
          // {
          //   url: "/AtollUpdate",
          //   exact: true,
          //   roles: ["SUPERADMIN", "ADMIN", "OPERATOR", "VIEW"],
          //   label: "Atoll Update",
          //   isMenuItem: true,
          //   main: Planning.AtollUpdate,
          // },
          // {
          //   url: "/file-analyze",
          //   exact: true,
          //   roles: ["SUPERADMIN", "ADMIN", "OPERATOR", "VIEW"],
          //   label: "FileAnalyze",
          //   isMenuItem: true,
          //   main: Planning.FileAnalyze,
          // },
          {
            url: '/dashboard/planning/view',
            exact: true,
            roles: ['SUPERADMIN', 'ADMIN', 'OPERATOR', 'VIEW'],
            label: 'View',
            isMenuItem: true,
            main: Planning.View,
          },
          {
            url: '/dashboard/planning/kml',
            exact: true,
            roles: ['SUPERADMIN', 'ADMIN', 'OPERATOR', 'VIEW'],
            label: 'KML',
            isMenuItem: true,
            main: Planning.KML,
          },
          {
            url: '/dashboard/planning/cell-file',
            exact: true,
            roles: ['SUPERADMIN', 'ADMIN', 'OPERATOR', 'VIEW'],
            label: 'Cell File',
            isMenuItem: true,
            main: Planning.CellFile,
          },
          {
            url: '/dashboard/planning/nemo',
            exact: true,
            roles: ['SUPERADMIN', 'ADMIN', 'OPERATOR', 'VIEW'],
            label: 'Nemo',
            isMenuItem: true,
            main: Planning.Nemo,
          },
          {
            url: '/dashboard/planning/cell-ref',
            exact: true,
            roles: ['SUPERADMIN', 'ADMIN', 'OPERATOR', 'VIEW'],
            label: 'Cell Ref',
            isMenuItem: true,
            main: Planning.CellRef,
          },
          {
            url: '/dashboard/planning/borders',
            exact: true,
            roles: ['SUPERADMIN', 'ADMIN', 'OPERATOR', 'VIEW'],
            label: 'Borders',
            isMenuItem: true,
            main: Planning.Borders,
          },
          {
            url: '/dashboard/planning/atoll-check',
            exact: true,
            roles: ['SUPERADMIN', 'ADMIN', 'OPERATOR', 'VIEW'],
            label: 'Atoll Check',
            isMenuItem: true,
            main: Planning.AtollCheck,
          },
          {
            url: '/dashboard/planning/violation',
            exact: true,
            roles: ['SUPERADMIN', 'ADMIN', 'OPERATOR', 'VIEW'],
            label: 'Violation',
            isMenuItem: true,
            main: Planning.Violation,
          },
          {
            url: '/dashboard/planning/export-atoll',
            exact: true,
            roles: ['SUPERADMIN', 'ADMIN', 'OPERATOR', 'VIEW'],
            label: 'Atoll Download',
            isMenuItem: true,
            main: Planning.AtollDownload,
          },
          {
            url: '/dashboard/planning/ep',
            exact: true,
            roles: ['SUPERADMIN', 'ADMIN', 'OPERATOR', 'VIEW'],
            label: 'EP Report',
            isMenuItem: true,
            main: Planning.EP_Report,
          },
        ],
      },
    ];
    if (managementUsers.includes(user)) {
      defaultAccess[2].items.unshift({
        url: '/dashboard/cm/dashboard',
        exact: true,
        roles: ['SUPERADMIN', 'ADMIN', 'OPERATOR', 'VIEW'],
        label: 'Dashboard',
        isMenuItem: true,
        main: CM_Dashboard,
        org: [],
      });
    }
    return defaultAccess;
  } else if (
    ['ictrc mvo', 'ictrc', 'rightel', 'test suhbcon'].includes(
      companyName.toLowerCase()
    )
  ) {
    return [
      {
        url: '/dashboard/overview',
        exact: true,
        roles: ['SUPERADMIN', 'ADMIN', 'OPERATOR', 'VIEW'],
        icon: 'pi pi-microsoft',
        label: 'Dasboard',
        isMenuItem: true,
        main: mainChart,
      },

      {
        name: '/dashboard/pm',
        exact: false,
        roles: ['SUPERADMIN', 'ADMIN', 'OPERATOR', 'VIEW'],
        icon: 'pi pi-chart-bar',
        label: 'PM and Reporting',
        isMenuItem: true,
        items: [
          // {
          //   url: "/performance-query-dashboard",
          //   exact: true,
          //   roles: ["SUPERADMIN", "ADMIN", "OPERATOR", "VIEW"],
          //   label: "PM Dashboard",
          //   isMenuItem: true,
          //   main: Workspace,
          //   org: []
          // },

          {
            url: '/dashboard/pm/rightel',
            exact: true,
            roles: ['SUPERADMIN', 'ADMIN', 'OPERATOR', 'VIEW'],
            label: 'KPi Browser',
            isMenuItem: true,
            main: Queries2,
            org: [],
          },
          {
            url: '/dashboard/pm/kpieditor',
            exact: true,
            roles: ['SUPERADMIN', 'ADMIN', 'OPERATOR', 'VIEW'],
            label: 'KPI Editor',
            isMenuItem: true,
            main: KPIeditor,
            org: [],
          },
          {
            url: '/dashboard/pm/cluster',
            exact: true,
            roles: ['SUPERADMIN', 'ADMIN', 'OPERATOR', 'VIEW'],
            label: 'Cluster',
            isMenuItem: true,
            main: Clusters,
            org: [],
          },
          {
            url: '/dashboard/pm/dashboard',
            exact: true,
            roles: ['SUPERADMIN', 'ADMIN', 'OPERATOR', 'VIEW'],
            label: 'Dashboards',
            isMenuItem: true,
            main: Dashboard,
            org: [],
          },
          {
            url: '/dashboard/pm/wpc',
            exact: true,
            roles: ['SUPERADMIN', 'ADMIN', 'OPERATOR', 'VIEW'],
            label: 'WPC (new)',
            isMenuItem: true,
            main: WPC,
            org: [],
          },

          {
            url: '/dashboard/pm/percent_change',
            exact: true,
            roles: ['SUPERADMIN', 'ADMIN', 'OPERATOR', 'VIEW'],
            label: 'Percent Change (new)',
            isMenuItem: true,
            main: Percent_change,
            org: [],
          },
          {
            url: '/dashboard/pm/psshare',
            exact: true,
            roles: ['SUPERADMIN', 'ADMIN', 'OPERATOR', 'VIEW'],
            label: 'PS share',
            isMenuItem: true,
            main: PSshare,
            org: [],
          },

          {
            url: '/dashboard/pm/utilization',
            exact: true,
            roles: ['SUPERADMIN', 'ADMIN', 'OPERATOR', 'VIEW'],
            label: 'Utilization(New)',
            isMenuItem: true,
            main: Utilization,
            org: [],
          },
          {
            url: '/dashboard/pm/carriershare',
            exact: true,
            roles: ['SUPERADMIN', 'ADMIN', 'OPERATOR', 'VIEW'],
            label: 'Sector Balance',
            isMenuItem: true,
            main: CarrierShare,
            org: [],
          },
          {
            url: '/dashboard/pm/rightel_ps_cs_daily',
            exact: true,
            roles: ['SUPERADMIN', 'ADMIN', 'OPERATOR', 'VIEW'],
            label: 'CS PS Load Daily',
            isMenuItem: true,
            main: Rightel_ps_cs_daily,
            org: [],
          },
          {
            url: '/dashboard/pm/wpc_4g',
            exact: true,
            roles: ['SUPERADMIN', 'ADMIN', 'OPERATOR', 'VIEW'],
            label: 'WPC 4G',
            isMenuItem: true,
            main: WPC,
            org: [],
          },

          {
            url: '/dashboard/pm/PPC',
            exact: true,
            roles: ['SUPERADMIN', 'ADMIN', 'OPERATOR', 'VIEW'],
            label: 'PPC',
            isMenuItem: true,
            main: PPC,
            org: [],
          },
          {
            url: '/dashboard/pm/wdc',
            exact: true,
            roles: ['SUPERADMIN', 'ADMIN', 'OPERATOR', 'VIEW'],
            label: 'WDC',
            isMenuItem: true,
            main: WDC,
            org: [],
          },
          // {
          //   url: "/dashboardUMTS",
          //   exact: true,
          //   roles: ["SUPERADMIN", "ADMIN", "OPERATOR", "VIEW"],
          //   label: "Dashboard UMTS",
          //   isMenuItem: true,
          //   main: DashboardUMTS,
          //   org: []
          // },
          {
            url: '/dashboard/pm/ReportRepo',
            exact: true,
            roles: ['SUPERADMIN', 'ADMIN', 'OPERATOR', 'VIEW'],
            label: 'Report Repository',
            isMenuItem: true,
            main: ReportRepo,
            org: [],
          },
          {
            url: '/dashboard/pm/pucch',
            exact: true,
            roles: ['SUPERADMIN', 'ADMIN', 'OPERATOR', 'VIEW'],
            label: 'PUCCH > -107',
            isMenuItem: true,
            main: PUCCH,
            org: [],
          },
          {
            url: '/dashboard/pm/rtwp',
            exact: true,
            roles: ['SUPERADMIN', 'ADMIN', 'OPERATOR', 'VIEW'],
            label: 'RTWP > -95',
            isMenuItem: true,
            main: RTWP,
            org: [],
          },
          {
            url: '/dashboard/pm/FrameLoss',
            exact: true,
            roles: ['SUPERADMIN', 'ADMIN', 'OPERATOR', 'VIEW'],
            label: 'Frame Loss',
            isMenuItem: true,
            main: FrameLoss,
            org: [],
          },
          {
            url: '/dashboard/pm/SleepingCellLTE',
            exact: true,
            roles: ['SUPERADMIN', 'ADMIN', 'OPERATOR', 'VIEW'],
            label: 'Sleeping Cell LTE',
            isMenuItem: true,
            main: SleepingCellLTE,
            org: [],
          },
          {
            url: '/dashboard/pm/SleepingCellUMTS',
            exact: true,
            roles: ['SUPERADMIN', 'ADMIN', 'OPERATOR', 'VIEW'],
            label: 'Sleeping Cell UMTS',
            isMenuItem: true,
            main: SleepingCellUMTS,
            org: [],
          },
        ],
      },
      {
        name: '/dashboard/planning',
        exact: false,
        roles: ['SUPERADMIN', 'ADMIN', 'OPERATOR', 'VIEW'],
        icon: 'pi pi-book',
        label: 'Planing',
        isMenuItem: true,
        items: [
          {
            url: '/dashboard/planning/cellRef',
            exact: true,
            roles: ['SUPERADMIN', 'ADMIN', 'OPERATOR', 'VIEW'],
            label: 'Cell Ref',
            isMenuItem: true,
            main: CellRef_Rightel,
            org: [],
          },
          {
            url: '/dashboard/planning/cellFile',
            exact: true,
            roles: ['SUPERADMIN', 'ADMIN', 'OPERATOR', 'VIEW'],
            label: 'Cell File',
            isMenuItem: true,
            main: CellFile_Rightel,
            org: [],
          },
          {
            url: '/dashboard/planning/KML',
            exact: true,
            roles: ['SUPERADMIN', 'ADMIN', 'OPERATOR', 'VIEW'],
            label: 'KML',
            isMenuItem: true,
            main: KML_Rightel,
            org: [],
          },
          {
            url: '/dashboard/planning/borders',
            exact: true,
            roles: ['SUPERADMIN', 'ADMIN', 'OPERATOR', 'VIEW'],
            label: 'Borders',
            isMenuItem: true,
            main: Borders_Rightel,
          },
          {
            url: '/dashboard/planning/nemo',
            exact: true,
            roles: ['SUPERADMIN', 'ADMIN', 'OPERATOR', 'VIEW'],
            label: 'Nemo',
            isMenuItem: true,
            main: Nemo_Rightel,
          },
        ],
      },
      {
        name: '/dashboard/cm',
        exact: false,
        roles: ['SUPERADMIN', 'ADMIN', 'OPERATOR', 'VIEW'],
        icon: 'pi pi-slack',
        label: 'CM',
        isMenuItem: true,
        items: [
          {
            url: '/dashboard/cm/import',
            exact: true,
            roles: ['SUPERADMIN', 'ADMIN', 'OPERATOR', 'VIEW'],
            label: 'Import',
            isMenuItem: true,
            main: Import_Rightel,
            org: [],
          },
          {
            url: '/dashboard/cm/compare',
            exact: true,
            roles: ['SUPERADMIN', 'ADMIN', 'OPERATOR', 'VIEW'],
            label: 'Compare',
            isMenuItem: true,
            main: Rightel_CM_Compare,
            org: [],
          },
          {
            url: '/dashboard/cm/cm/download',
            exact: true,
            roles: ['SUPERADMIN', 'ADMIN', 'OPERATOR', 'VIEW'],
            label: 'Download',
            isMenuItem: true,
            main: Download_Rightel,
            org: [],
          },
        ],
      },
    ];
  } else if (
    ['test subcfon', 'brtel mci', 'brtel', 'br tel', 'br tel mci'].includes(
      companyName.toLowerCase()
    )
  ) {
    return [
      {
        url: '/dashboard/overview',
        exact: true,
        roles: ['SUPERADMIN', 'ADMIN', 'OPERATOR', 'VIEW'],
        icon: (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="h-6 w-6"
            viewBox="0 0 20 20"
            fill="currentColor"
          >
            <path
              fillRule="evenodd"
              d="M3 3a1 1 0 000 2v8a2 2 0 002 2h2.586l-1.293 1.293a1 1 0 101.414 1.414L10 15.414l2.293 2.293a1 1 0 001.414-1.414L12.414 15H15a2 2 0 002-2V5a1 1 0 100-2H3zm11 4a1 1 0 10-2 0v4a1 1 0 102 0V7zm-3 1a1 1 0 10-2 0v3a1 1 0 102 0V8zM8 9a1 1 0 00-2 0v2a1 1 0 102 0V9z"
              clipRule="evenodd"
            />
          </svg>
        ),
        label: 'Dasboard',
        isMenuItem: true,
        main: Overview,
      },

      {
        name: '/dashboard/cm',
        exact: false,
        roles: ['SUPERADMIN', 'ADMIN', 'OPERATOR', 'VIEW'],
        icon: (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="h-6 w-6"
            viewBox="0 0 20 20"
            fill="currentColor"
          >
            <path
              fillRule="evenodd"
              d="M5 3a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2V5a2 2 0 00-2-2H5zm9 4a1 1 0 10-2 0v6a1 1 0 102 0V7zm-3 2a1 1 0 10-2 0v4a1 1 0 102 0V9zm-3 3a1 1 0 10-2 0v1a1 1 0 102 0v-1z"
              clipRule="evenodd"
            />
          </svg>
        ),
        label: 'CM',
        isMenuItem: true,
        items: [
          {
            url: '/download',
            exact: true,
            roles: ['SUPERADMIN', 'ADMIN', 'OPERATOR', 'VIEW'],
            label: 'CM Download',
            isMenuItem: true,
            main: BrTelMCI_CM_Download,
            org: [],
          },
          {
            url: '/compare',
            exact: true,
            roles: ['SUPERADMIN', 'ADMIN', 'OPERATOR', 'VIEW'],
            label: 'CM Compare',
            isMenuItem: true,
            main: BrTelMCI_CM_Compare,
            org: [],
          },
          {
            url: '/view',
            exact: true,
            roles: ['SUPERADMIN', 'ADMIN', 'OPERATOR', 'VIEW'],
            label: 'Parameter Aras',
            isMenuItem: true,
            main: Active_Parameter_Aras,
            org: [],
          },
          {
            url: '/cminpm',
            exact: true,
            roles: ['SUPERADMIN', 'ADMIN', 'OPERATOR', 'VIEW'],
            label: 'CM Check in PM',
            isMenuItem: true,
            main: BrTelMCI_CmNotInPM,
            org: [],
          },
          {
            url: '/impot',
            exact: true,
            roles: ['SUPERADMIN', 'ADMIN', 'OPERATOR', 'VIEW'],
            label: 'Links',
            isMenuItem: true,
            main: BrTelMCI_Import,
            org: [],
          },
        ],
      },
      {
        name: '/dashboard/pm',
        exact: false,
        roles: ['SUPERADMIN', 'ADMIN', 'OPERATOR', 'VIEW'],
        icon: (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="h-6 w-6"
            viewBox="0 0 20 20"
            fill="currentColor"
          >
            <path
              fillRule="evenodd"
              d="M5 3a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2V5a2 2 0 00-2-2H5zm9 4a1 1 0 10-2 0v6a1 1 0 102 0V7zm-3 2a1 1 0 10-2 0v4a1 1 0 102 0V9zm-3 3a1 1 0 10-2 0v1a1 1 0 102 0v-1z"
              clipRule="evenodd"
            />
          </svg>
        ),
        label: 'PM',
        isMenuItem: true,
        items: [
          {
            url: '/browser',
            exact: true,
            roles: ['SUPERADMIN', 'ADMIN', 'OPERATOR', 'VIEW'],
            label: 'PM Browser',
            isMenuItem: true,
            main: BrTelMCI_PM_Browser,
            org: [],
          },
        ],
      },
      {
        name: '/dashboard/planning',
        exact: false,
        roles: ['SUPERADMIN', 'ADMIN', 'OPERATOR', 'VIEW'],
        icon: (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="h-6 w-6"
            viewBox="0 0 20 20"
            fill="currentColor"
          >
            <path
              fillRule="evenodd"
              d="M5 3a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2V5a2 2 0 00-2-2H5zm9 4a1 1 0 10-2 0v6a1 1 0 102 0V7zm-3 2a1 1 0 10-2 0v4a1 1 0 102 0V9zm-3 3a1 1 0 10-2 0v1a1 1 0 102 0v-1z"
              clipRule="evenodd"
            />
          </svg>
        ),
        label: 'Planning',
        isMenuItem: true,
        items: [
          {
            url: '/cellRef',
            exact: true,
            roles: ['SUPERADMIN', 'ADMIN', 'OPERATOR', 'VIEW'],
            label: 'Cell Ref',
            isMenuItem: true,
            main: CellRef_Brtel,
            org: [],
          },
          {
            url: '/cellFile',
            exact: true,
            roles: ['SUPERADMIN', 'ADMIN', 'OPERATOR', 'VIEW'],
            label: 'Cell File',
            isMenuItem: true,
            main: CellFile_Brtel,
            org: [],
          },
          {
            url: '/KML',
            exact: true,
            roles: ['SUPERADMIN', 'ADMIN', 'OPERATOR', 'VIEW'],
            label: 'KML',
            isMenuItem: true,
            main: KML_Brtel,
            org: [],
          },
          {
            url: '/borders',
            exact: true,
            roles: ['SUPERADMIN', 'ADMIN', 'OPERATOR', 'VIEW'],
            label: 'Borders',
            isMenuItem: true,
            main: Borders_Brtel,
          },
          {
            url: '/nemo',
            exact: true,
            roles: ['SUPERADMIN', 'ADMIN', 'OPERATOR', 'VIEW'],
            label: 'Nemo',
            isMenuItem: true,
            main: Nemo_Brtel,
          },
        ],
      },
    ];
  } else {
    return [];
  }
}
